import { motion } from "framer-motion";

type Props = {
  image: string;
};

const Partner = ({ image }: Props) => {
  return (
    <motion.div
      className="flex w-[250px] justify-center mx-auto pb-16"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0 }}
      transition={{ duration: 0.5 }}
      variants={{
        hidden: { opacity: 0, x: -50 },
        visible: { opacity: 1, x: 0 },
      }}
    >
      <img src={image} alt={`${image}`} />
    </motion.div>
  );
};

export default Partner;
